import Icon from '../components/Icon.vue'

Icon.register({"user-tie":{"width":448,"height":512,"paths":[{"d":"M224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM319.8 288.6L272 480 240 344 272 288H176L208 344 176 480 128.2 288.6C56.9 292 0 350.3 0 422.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V422.4C448 350.3 391.1 292 319.8 288.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-tie.js
// module id = 729f
// module chunks = 0